import React from 'react';
import { Building } from "assets/icons";
import UseContext from "hooks/useContext";
import SidebarUnitMobile from "components/sidebar/components/SidebarUnitMobile";

const CompanyML = ({ pathname }) => {
    const { language } = UseContext();
    const isActive = pathname.includes("company");
    
    return (
        <SidebarUnitMobile routeName={"Entreprise"} routeSidebar={"/company"}>
            <div className="flex flex-col justify-center items-center">
                <span className='shrink-0'>
                    <Building wh={28} color={isActive ? '#FF9600' : '#6B7280'} />
                </span>
                <span
                    className={`text-[9px] font-medium whitespace-normal text-center ${
                        isActive && "!text-[#FF9600]"
                    }`}
                >
                    {language.getValue('sidebar.company', 'Entreprise')}
                </span>
            </div>
        </SidebarUnitMobile>
    );
};

export default CompanyML;

